import React, { Component } from 'react';
import Select from 'react-select';
import styled from 'styled-components';


const Users = [
  { label: "Brad", value: 1 },
  { label: "Johny", value: 2 },
];
const Products = [
  { label: "Analytics Shift", value: 1 },
  { label: "Boomberang", value: 2 },
];
const customStyles = {
  control: (provided, state) => ({
    ...provided,
    background: '#fff',
    borderColor: '#9e9e9e',
    minHeight: '35px',
    height: '35px',
  }),

  valueContainer: (provided, state) => ({
    ...provided,
    height: '40px',
    padding: '0 6px'
  }),

  indicatorSeparator: state => ({
    display: 'none',
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: '30px',
  }),
};

class AdminDropDown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedUser: undefined,
      selectedProduct: undefined,
      users: [],
      products: []
    }
    this.state.formHide = { visibility: this.props.name ? 'visible' : 'hidden' }

  }

  componentDidMount() {

  }

  componentDidUpdate(prevProps) {

    if (this.props.usersList !== prevProps.usersList) {
      const { usersList } = this.props;
      if (usersList) {
        let users = usersList.map( usr => { return { label: usr.firstname, value: usr }});
        let firstProductMap = users[0].value.products.map( prd => { return { label: prd.name, value: prd }});
        this.setState({
          users,
          selectedUser: users[0],
          products: firstProductMap,
          selectedProduct: firstProductMap[0]
        }, () => {
          this.handleSelectProduct(firstProductMap[0]);
        });
      }
    }
  }
  handleSelectProduct(selectedProduct) {
    this.props.dropDownSelected(this.state.selectedUser.value, selectedProduct.value);
    this.setState({
      selectedProduct
    })
  }
  handleSelectUser(selectedUser) {
    console.log(selectedUser);
    let productDetails = selectedUser.value.products;
    let products = productDetails.map(prd => { return { label: prd.name, value: prd}})
    console.log("User is selected");
    this.setState({
      selectedUser: selectedUser,
      products,
      selectedProduct: products[0]
    }, () => {
      this.props.dropDownSelected(this.state.selectedUser.value, products[0].value);
    });
  }
  render() {
    return (
        <Container>
          <div className="col-md-6">
            <p>Select a User</p>
            <Select
              className="form-container"
              classNamePrefix="select"
              label="Single select"
              options={this.state.users}
              styles={customStyles}
              onChange={this.handleSelectUser.bind(this)}
              value={this.state.selectedUser}
            />
          </div>
          <div className="col-md-6">
            <p>Select a Product</p>
            <Select
              className="form-container"
              classNamePrefix="select"
              label="Single select"
              options={this.state.products}
              styles={customStyles}
              onChange={this.handleSelectProduct.bind(this)}
              value={this.state.selectedProduct}
            />
          </div>
        </Container>
    )
  }

}

export default AdminDropDown;

const Container = styled.div`
  display: flex;
  margin: 0 -15px;
  p {
    font-size: 15px;
    font-weight: 500;
    margin-left: 16px;
    margin-bottom: 5px;
    font-family: RobotoMedium;
  }
  .select__control {
    background-color: #f8f8f8;
    border-radius: unset;
    color: #B2B3B7 !important;
    border-color: #B2B3B7 !important;
    height: auto;
    padding: 10px 12px;
  }
  .select__input {
    color: transparent;
  }
  .select__value-container {
    height: auto;
    font-size: 16px;
  }
  .select__single-value {
    color: #0A0E17;
  }
  .select__indicator {
    color: #0A0E17;
  }
`;

const AdminContainer = styled.div`
width: 80%;
height: 10%;
margin-right: 20px;
margin-bottom: 20px;
margin-top: 20px;
.select__input {
  color: transparent;
}
    > p {
        font-size: 15px;
        font-weight: 500;
    }
`;
